import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { areas, siteInfo } from '../data/mock';
import { Button } from './ui/button';
import { MapPin, ArrowRight } from 'lucide-react';

const AreasSection = () => {
  const { language, t } = useLanguage();

  return (
    <section id="areas" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-medium text-sm uppercase tracking-wider">
            {language === 'en' ? 'Destinations' : 'Destinations'}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mt-3 mb-4">
            {t.areas.title}
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto text-lg">
            {t.areas.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {areas.map((area) => (
            <div
              key={area.id}
              className="group relative rounded-2xl overflow-hidden h-80"
            >
              <img
                src={area.image}
                alt={area[language].name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              
              <div className="absolute inset-0 p-8 flex flex-col justify-end">
                <div className="flex items-center gap-2 text-teal-400 mb-2">
                  <MapPin className="w-4 h-4" />
                  <span className="text-sm font-medium uppercase tracking-wider">
                    {area.id === 'south' ? (language === 'en' ? 'South' : 'Sud') :
                     area.id === 'north' ? (language === 'en' ? 'North' : 'Nord') :
                     area.id === 'east' ? (language === 'en' ? 'East' : 'Est') :
                     (language === 'en' ? 'West' : 'Ouest')}
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-white mb-2">
                  {area[language].name}
                </h3>

                <p className="text-white/80 text-sm mb-4 line-clamp-2">
                  {area[language].description}
                </p>

                <div className="flex flex-wrap gap-2 mb-5">
                  {area[language].highlights.slice(0, 4).map((highlight, idx) => (
                    <span
                      key={idx}
                      className="text-xs bg-white/20 backdrop-blur-sm text-white px-3 py-1 rounded-full"
                    >
                      {highlight}
                    </span>
                  ))}
                </div>

                <a
                  href={`${siteInfo.whatsappLink}?text=${encodeURIComponent(
                    language === 'en'
                      ? `Hi, I'm interested in tours in ${area.en.name}.`
                      : `Bonjour, je suis intéressé(e) par les excursions dans le ${area.fr.name}.`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                >
                  <Button className="bg-white text-stone-900 hover:bg-teal-500 hover:text-white transition-colors">
                    {language === 'en' ? 'Explore Area' : 'Explorer la Région'}
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasSection;